import * as React from 'react';
import './ExportComponent.css';

import {t} from 'react-multi-lang';
import {IExportProps} from "../../containers/ExportContainer";
import IExportFormat from "../../interfaces/IExportFormat";
import IExportOptions from "../../interfaces/IExportOptions";
import {exportJSON} from "../../utils/exportJSON";

interface IExportState {
    exportFormat: IExportFormat,
    exportOption: IExportOptions,
}

class ExportComponent extends React.PureComponent<IExportProps, IExportState> {
    private static exportToJson(objectData: any) {
        const filename = "export.json";
        const contentType = "application/json;charset=utf-8;";
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            const blob = new Blob([decodeURIComponent(encodeURI(JSON.stringify(objectData)))], {type: contentType});
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            const a = document.createElement('a');
            a.download = filename;
            a.href = 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(objectData));
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }

    constructor(props: IExportProps) {
        super(props);

        this.state = {
            exportFormat: IExportFormat.Literature_Wizard,
            exportOption: IExportOptions.OnlyAccepted,
        };

        this.handleSelectChangeOptions = this.handleSelectChangeOptions.bind(this);
        this.handleSelectChangeFormat = this.handleSelectChangeFormat.bind(this);
        this.downloadExport = this.downloadExport.bind(this);
    }

    public render() {
        return (
            <>
                <div className="w_header">{t('export.export')}</div>
                <div className="w_component">
                    <div className="w_component_row">
                        <form onSubmit={this.downloadExport}>
                            <div>{t('export.description')}</div>
                            <div className="mt-2">{t('export.instructions')}</div>
                            <div className="input-group">
                                <select className="custom-select" id="export_select"
                                        value={this.state.exportOption} onChange={this.handleSelectChangeOptions}>
                                    <option value={IExportOptions.OnlyAccepted}>
                                        {t('export.dropdown.only_accepted')}
                                    </option>
                                    <option value={IExportOptions.AcceptedAndTentative}>
                                        {t('export.dropdown.accepted_tentative')}
                                    </option>
                                    <option value={IExportOptions.All}>
                                        {t('export.dropdown.all')}
                                    </option>
                                </select>
                            </div>
                            <div className="mt-2">{t('export.instructions_2')}</div>
                            <div className="input-group">
                                <select className="custom-select" id="format_select"
                                        value={this.state.exportFormat} onChange={this.handleSelectChangeFormat}>
                                    <option value={IExportFormat.Literature_Wizard}>
                                        {t('export.dropdown.own_format')}
                                    </option>
                                    <option value={IExportFormat.SWOFI}>
                                        {t('export.dropdown.swofi_format')}
                                    </option>
                                </select>
                            </div>
                            <button className="input-group-text mt-2" id="" title={t('export.download_hover')}>
                                {t('export.download')}
                            </button>
                        </form>
                    </div>
                </div>
            </>
        );
    }

    private handleSelectChangeOptions(event: any) {
        this.setState({
            ...this.state,
            exportOption: parseInt(event.target.value, 10),
        });
    }

    private handleSelectChangeFormat(event: any) {
        this.setState({
            ...this.state,
            exportFormat: parseInt(event.target.value, 10),
        });
    }

    private downloadExport(event: any) {
        event.preventDefault();

        const jsonFormat = exportJSON(this.props.sources, this.state.exportOption, this.state.exportFormat);
        ExportComponent.exportToJson(jsonFormat);
    }
}

export default ExportComponent;



// WEBPACK FOOTER //
// ./src/components/ExportComponent/ExportComponent.tsx